exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".success_item[data-v-1fda619b]{background-color:#6bab5c}.marker-number[data-v-1fda619b]{min-height:22px;border-top-left-radius:5px;border-top-right-radius:5px}.marker-answer[data-v-1fda619b]{min-height:18px;background:#f5f5f5;border-bottom-left-radius:5px;border-bottom-right-radius:5px}", ""]);

// exports
